import { create } from "zustand";
import { persist } from "zustand/middleware";

import type { ChartLayout, WorkspaceChartView } from "@/types/workspace";

interface WorkspaceState {
  activeTemplateId: string | null;
  shortcutsOverlayOpen: boolean;
  setActiveTemplateId: (templateId: string | null) => void;
  openShortcutsOverlay: () => void;
  closeShortcutsOverlay: () => void;
  toggleShortcutsOverlay: () => void;
}



export const useWorkspaceStore = create<WorkspaceState>()(
  persist(
    (set) => ({
      activeTemplateId: null,
      shortcutsOverlayOpen: false,
      setActiveTemplateId: (templateId) => set({ activeTemplateId: templateId }),
      openShortcutsOverlay: () => set({ shortcutsOverlayOpen: true }),
      closeShortcutsOverlay: () => set({ shortcutsOverlayOpen: false }),
      toggleShortcutsOverlay: () =>
        set((state) => ({ shortcutsOverlayOpen: !state.shortcutsOverlayOpen })),
    }),
    {
      name: "lytick-workspace-state",
      partialize: (state) => ({
        activeTemplateId: state.activeTemplateId,
      }),
    },
  ),
);
